/** Shopware storefront: order confirmation is a full navigation to checkout finish. */
export function isCheckoutFinishUrl(url: string): boolean {
  return url.includes('/checkout/finish');
}
